import { useQueries } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Card, Spinner } from "../components/ui";

/** A count per entity. Deliberately cheap — it reads the `total` the list
 *  envelope already returns rather than adding a bespoke stats endpoint. */
export default function Dashboard() {
  const results = useQueries({
    queries: [
      {
        queryKey: ["feedbacks", "count"],
        queryFn: () => api.feedbacks.list({ limit: 1 }),
      },
      {
        queryKey: ["staff", "count"],
        queryFn: () => api.staff.list({ limit: 1 }),
      },
      {
        queryKey: ["replies", "count"],
        queryFn: () => api.replies.list({ limit: 1 }),
      },
    ],
  });

  const cards = [
    { label: "Feedbacks", to: "/feedbacks", idx: 0 },
    { label: "Staff", to: "/staff", idx: 1 },
    { label: "Replies", to: "/replies", idx: 2 },
  ];

  if (results.some((r) => r.isLoading)) return <Spinner />;

  return (
    <div>
      <header className="mb-6">
        <h1 className="text-xl font-semibold">Guest Feedback Desk</h1>
        <p className="text-sm text-muted">Track guest feedback and never miss a reply</p>
      </header>

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {cards.map((c) => (
          <Link key={c.to} to={c.to}>
            <Card className="p-5 transition hover:border-brand">
              <p className="text-sm text-muted">{c.label}</p>
              <p className="mt-1 text-3xl font-semibold tabular-nums">
                {results[c.idx]?.data?.total ?? 0}
              </p>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
}
